'use client'

import { useContentLayout } from '@/contexts/ContentLayoutContext'
import { CMS_BLOCKS_CLASS, getLayoutClasses } from '@/helpers/layout'
import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'

export type CMSBlocksProps = ComponentProps<'div'>

export const CMSBlocks: FC<CMSBlocksProps> = ({ className, children, ...props }) => {
	const layout = useContentLayout()
	const layoutClasses = getLayoutClasses(layout)
	return (
		<div {...props} className={cx(CMS_BLOCKS_CLASS, layoutClasses, className)}>
			{children}
		</div>
	)
}
